import {
    Component,
    Input,
    SimpleChanges,
    OnChanges,
} from '@angular/core';
import {
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { FilterPanelComponent } from '../../../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../../../common/grid-page.component';
import {
    InvoicePurchaseOrderHistoryGridViewDto,
    InvoicePurchaseOrderStatus,
} from '@services';
import EnumUtils from '../../../../../shared/enum-utils';
import { CapitalCasePipe } from '../../../../../pipes/capital-case.pipe';
import { CommonModule } from '@angular/common';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';
import { CustomStore } from 'devextreme-aspnet-data-nojquery';

@Component({
    selector: 'app-invoice-purchase-order-history',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSearchPanelComponent,
        DxoSelectionComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxiColumnComponent,
        DxTemplateDirective,
        CapitalCasePipe,
        FilterPanelComponent,
        DxFormComponent,
        UserAvatarEmailComponent,
    ],
    templateUrl: './invoice-purchase-order-history.component.html',
})
export class InvoicePurchaseOrderHistoryComponent
    extends GridPageComponent<InvoicePurchaseOrderHistoryGridViewDto>
    implements OnChanges
{
    @Input() number: string | null = null;
    protected override exportName: string = 'Invoice PO Report';
    protected offset: number = 160;
    public dateTimeFormat = DATE_TIME_FORMAT;
    dataSource :  CustomStore | InvoicePurchaseOrderHistoryGridViewDto[] = [];

    statusOptions = EnumUtils.getEnumOptions(InvoicePurchaseOrderStatus);

    createdByFilter = this.userNameOrEmailFilter('createdBy');

    protected override filterConfig: FilterConfig[] = [
        {
            field: 'createdBy.name',
            op: 'contains',
            customFilter: this.createdByFilter,
        },
        { field: 'created', op: '>=' },
        { field: 'status', op: '=' },
    ];

    constructor() {
        super();
        this.init(InvoicePurchaseOrderHistoryGridViewDto);
    }

    protected getBadgeClass(status: InvoicePurchaseOrderStatus | undefined): string {
        return EnumUtils.getInvoicePurchaseOrderStatusBadgeClass(status);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['number']) {
            this.dataSource = this.dataSources.invoicePurchaseOrderHistory(
                this.number,
            );
        }
    }
}
